import React, { CSSProperties, PropsWithChildren, ReactNode } from 'react';
import { ErrorBoundary } from '@sentry/react';
import { GenericErrorFallback, IForbiddenErrorConfig } from './GenericErrorFallback';
import { GenericLoadingFallback } from './GenericLoadingFallback';

export interface IGenericFallbacksWrapperProps extends PropsWithChildren {
  style?: CSSProperties;
  suspenseFallback?: ReactNode;
  forbiddenFallback?: IForbiddenErrorConfig;
}

export function GenericFallbacksWrapper(props: IGenericFallbacksWrapperProps) {
  const { children, style, forbiddenFallback } = props;
  const suspenseFallback = props.suspenseFallback ?? <GenericLoadingFallback />;

  return (
    <ErrorBoundary
      fallback={({ error, resetError }) => (
        <GenericErrorFallback
          error={error}
          resetError={resetError}
          style={style ?? {}}
          forbiddenConfig={forbiddenFallback}
        />
      )}
    >
      <React.Suspense fallback={suspenseFallback}>{children}</React.Suspense>
    </ErrorBoundary>
  );
}
